import React from 'react';
import Toasts from './toasts';
import { ToastContainer } from 'react-bootstrap';
import { useToast } from '../../contexts';

const ToastsContainer = () => {
    const { toast } = useToast();

    return (
        <ToastContainer className={toast.position}
            style={{ zIndex: 1056 }}>
            <Toasts />
        </ToastContainer>
    )
}

export default ToastsContainer;
